import { render, staticRenderFns } from "./GoodsAttrbuit.vue?vue&type=template&id=9eae6fa0&scoped=true"
import script from "./GoodsAttrbuit.vue?vue&type=script&lang=js"
export * from "./GoodsAttrbuit.vue?vue&type=script&lang=js"
import style0 from "./GoodsAttrbuit.vue?vue&type=style&index=0&id=9eae6fa0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eae6fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9eae6fa0')) {
      api.createRecord('9eae6fa0', component.options)
    } else {
      api.reload('9eae6fa0', component.options)
    }
    module.hot.accept("./GoodsAttrbuit.vue?vue&type=template&id=9eae6fa0&scoped=true", function () {
      api.rerender('9eae6fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/creatStore2/modules/GoodsAttrbuit.vue"
export default component.exports